import Mixin from 'mixmatch';

export default class Update extends Mixin {
  async update(id, object) {
    const options = {
      method: 'PUT',
      // @ts-ignore
      path: this.member(id),
      // @ts-ignore
      body: this.attributesForObject(object),
    };
    // @ts-ignore
    const body = await this.call(options);
    // @ts-ignore
    return JSON.parse(body)[this.resourceName];
  }
}
